import { Component } from '@angular/core';
import { NgbCarouselConfig, NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'ds-carusel',
    styleUrls: ['./carusel.component.scss'],
    templateUrl: './carusel.component.html',
    standalone: true,
    imports: [NgbCarouselModule],
    providers: [NgbCarouselConfig]
})

export class CaruselComponent {

    constructor(config: NgbCarouselConfig) {
        config.interval = 5000;
        config.wrap = true;
        config.keyboard = false;
        config.pauseOnHover = false;
        config.showNavigationArrows = false;
        config.showNavigationIndicators = false;
    }
    
}

// https://ng-bootstrap.github.io/#/components/carousel/examples